<script setup lang="ts">
import globalFunctions from '@/ts/global-functions.ts';
import { zendeskHidden } from '@/ts/management/zendesk-management.ts';
import model from '@/ts/model.ts';
import { ref } from 'vue';
import LoadingSpinner from './loading-spinner.vue';
import ChatIcon from '@/assets/icons/chat-icon.svg?raw';

const loading = ref<boolean>(false);
const initialized = ref<boolean>(false);

function onClick(){
    if(loading.value || initialized.value) return;

    const disposable = model.on('ZendeskLoaded', () => {
        disposable();
        loading.value = false;
        initialized.value = true;
    });

    globalFunctions.openChat();
    loading.value = true;
}
</script>

<template>
    <template v-if="!zendeskHidden && !initialized">
        <teleport to="body" defer>
            <button id="zendesk-start-btn" @click.prevent.stop="onClick">
                <template v-if="loading">
                    <loading-spinner :small-logo="true" />
                </template>
                <template v-else>
                    <div v-html="ChatIcon" class="icon"></div><div>Chat</div>
                </template>
            </button>
        </teleport>
    </template>
</template>

<style lang="scss" scoped>
    @use '@/scss/shared';
    @use 'sass:color';

    #zendesk-start-btn{
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 14px;
        right: 14px;
        border-radius: 100px;
        z-index: 999999;
        padding: 12px 23px;
        font-weight: bolder;
        font-size: 15px;
        border: none;
        cursor: pointer;
        & > *{
            flex: 1;
        }
        &,
        & > *{
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
        }
        & > .icon{
            width: 20px;
            padding-right: 10px;
        }
        @include shared.site() using($site-key) {
            background-color: color.adjust(shared.theme-color('primary_3', $site-key), $lightness: -10%);
        }
    }
</style>